import React, {useCallback, useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom"
import Swal from "sweetalert2";
import axios from 'axios'
// import { toast } from 'react-toastify';
// import Loading from "../../components/loading";
import Grid from '@mui/joy/Grid';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Autocomplete from '@mui/joy/Autocomplete';
import Input from '@mui/joy/Input';
// SERVICES
import AccountSeervice from "../../services/accountService";
import OperationFileService from "../../services/operationFileService";


function SendAuth() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)
    const initialized = useRef(false)
    const [listAccounts, setListAccounts] = useState([])
    let defaultDate = new Date().toISOString().slice(0,10);

    // Search Form
    const [model, setModel] = useState({
        date: defaultDate,
        account: '',
    })

    useEffect(() => {
        if (!initialized.current) {
            doLoad()
            initialized.current = true
        }
    }, [false]);

    const doLoad = useCallback( 
        async () => {
            try {
                setLoading(true)
                // Comitentes
                const responseAccount = await AccountSeervice.getAccountAutocomplete()
                setListAccounts(responseAccount.data)  
                initialized.current = true
            } catch (e) {
                if (axios.isAxiosError(e)) {
                    const statusCode = e.response?.status
                    const error = e.response?.data.errors;
                    
                    if(statusCode && statusCode !== 401){
                        Swal.fire({
                            title: 'ERROR',
                            text: error[0].detail,
                            icon: 'error',
                            confirmButtonText: 'OK',
                            confirmButtonColor: '#f13939'
                        })
                    }else{
                        sessionStorage.removeItem("userProfile");
                        navigate('/')
                        window.location.reload();
                    }
                }
            } finally{ setLoading(false) }

        }
    )

    const selectComitente = async (obj) => {
        if(obj !== null){
            setModel({
                ...model,
                account: obj,
            })
       }else{
        setModel({
                ...model,
                account: "",
            })
       }   
    }

    const doExecute = async () => {
        setLoading(true)
        if(validateForm()){
            if(model.account !== ''){
                // REENVIO
                Swal.fire({
                    title: "Atención!",
                    text: "Ud. esta por realizar un REENVIO de todas las Autorizaciones para el comitente seleccionado!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Ejecutar",
                    confirmButtonColor: "#83766d"
                }).then((result) => {
                    if(result.isConfirmed){
                        try {
                            OperationFileService.setOperationResendAuthNotification({account: model.account.account})
                            .then((response) => {
                                Swal.fire({
                                    title: "IMPORTACION",
                                    text: "Se ha iniciadio en proceso de REENVIO de autorizaciones.",
                                    icon: "success",
                                })
                            })
                            .catch((error) => {
                                if(error.response.status !== 401){
                                    Swal.fire({
                                        title: 'Ooops?',
                                        text: error.response.data.errors[0].detail,
                                        icon: 'error',
                                        confirmButtonText: 'OK',
                                        confirmButtonColor: '#f13939'
                                    })
                                }else{
                                    sessionStorage.removeItem("userProfile");
                                    navigate('/')
                                    window.location.reload();
                                }
                            })
                            /* const response = OperationFileService.setOperationResendAuthNotification({account: model.account})
                            if(response.status == 200){
                                Swal.fire({
                                    title: "IMPORTACION",
                                    text: "Se ha iniciadio en proceso de REENVIO de autorizaciones.",
                                    icon: "success",
                                })
                            } */

                        } catch (error) {
                            if(error.status !== 401){
                                Swal.fire({
                                    title: "ERROR",
                                    text: error.data.errors[0].detail[0],
                                    icon: "error",
                                    dangerMode: true,
                                })
                            }
                        } finally{ setLoading(false) }
                    }
                })
            }else{
            // ENVIO
                Swal.fire({
                    title: "Atención!",
                    text: "Ud. esta por realizar un ENVIO de todas las Autorizaciones!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Ejecutar",
                    confirmButtonColor: "#83766d"
                }).then((result) => {
                    if(result.isConfirmed){
                        try {
                            OperationFileService.setOperationSendAuthNotification(model)
                            .then((response) => {
                                Swal.fire({
                                    title: "IMPORTACION",
                                    text: "Se ha iniciadio en proceso de ENVIO de autorizaciones.",
                                    icon: "success",
                                })
                            })
                            .catch((error) => {
                                if(error.response.status !== 401){
                                    Swal.fire({
                                        title: 'Ooops?',
                                        text: error.response.data.errors[0].detail,
                                        icon: 'error',
                                        confirmButtonText: 'OK',
                                        confirmButtonColor: '#f13939'
                                    })
                                }else{
                                    sessionStorage.removeItem("userProfile");
                                    navigate('/')
                                    window.location.reload();
                                }
                            })
                            /* const response = OperationFileService.setOperationSendAuthNotification(model)
                            if(response.status == 200){
                                Swal.fire({
                                    title: "IMPORTACION",
                                    text: "Se ha iniciadio en proceso de ENVIO de autorizaciones.",
                                    icon: "success",
                                })
                            } */
                        } catch (error) {
                            if(error.status !== 401){
                                Swal.fire({
                                    title: "ERROR",
                                    text: error.data.errors[0].detail[0],
                                    icon: "error",
                                    dangerMode: true,
                                })
                            }
                        } finally{ setLoading(false) }
                    }
                })
            }
        }else{
            Swal.fire({
                title: "ERROR",
                text: "Debe completar la fecha para poder procesar los datos.",
                icon: "error",
                dangerMode: true,
            })
        }
    }

    function validateForm(){
        var rta = true;
        if(model.date === '' || model.date === null) {return false;}
        return rta;
    }

    return (
       
        <div className="container-fluid flex-grow-1 container-p-y">

            <div className="row">
                <div className="col">
                    <h4 className="fw-bold py-3 mb-2">
                        <span className="text-muted fw-light">Configuración / </span> Envio de Autorizaciones
                    </h4>
                </div>
            </div>

            <div className="card">
                <div className="card-body">

                    <Grid className="card-body" container spacing={2} sx={{ flexGrow: 1 }}>        
                        <Grid xs={3}>
                            <FormControl>
                                <FormLabel className="form-labels">Fecha</FormLabel>
                                <Input size="md" type="date"
                                     value={model.date}
                                     onChange={(e)=> setModel({...model, date: e.target.value})}
                                />
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Comitente</FormLabel>
                                <Autocomplete 
                                    autoFocus
                                    options={listAccounts} 
                                    getOptionLabel={option => option.name +' - '+ option.account }
                                    slotProps={{
                                        listbox: {
                                            sx: (theme) => ({
                                            zIndex: theme.vars.zIndex.modal
                                            })
                                        }
                                    }}
                                    placeholder="Seleccione un Comitente" 
                                    onChange={(event, newValue) => { selectComitente(newValue); }}
                                />  
                            </FormControl>
                        </Grid>
                        <Grid xs={2}>
                            <button type="button" className="btn btn-info mt-4 d-grid w-100" onClick={() => doExecute()}>Ejecutar</button>      
                        </Grid>
                    </Grid>

                    {/* NOTA */}
                    <div className="alert alert-info" role="alert">
                        <h5 className="alert-heading">Nota</h5>
                        <p>
                            <strong>Envio:</strong> Para realizar el envio a la totalidad de los comitentes, <strong>solo</strong> debe colocar la fecha que desea procesar.
                            <br></br>
                            <strong>Reenvio:</strong> Para realizar el reenvio es <strong>obligatorio</strong> colocar el comintente
                        </p>
                    </div>
                
                </div>
            
            </div>

        </div>        
    );

}

export default SendAuth;